export default __webpack_public_path__ + "static/media/pricingbanner.16425c42.jpg";